export default __webpack_public_path__ + "astern/fonts/Abel-Regular.b895fdba2506b00a799a71e617c14556.woff2";